import * as React from "react";
import {CSSProperties, ReactElement, ReactNode} from "react";

export enum Status {
    PENDING = 'pending',
    LOADING = 'loading',
    LOADED = 'loaded',
    FAILED = 'failed',
};

export interface ImageLoaderProps {
    src: string;
    className: string;
    srcSet?: string;
    onLoad?: (evt: Event) => void;
    onError?: (err: ErrorEvent) => void;
    children?: ReactNode;
    style?: CSSProperties;
}

interface IImageLoaderState {
    readonly status: string
}

/**
 * Implementation based on
 * https://github.com/DeedMob/react-load-image
 */
export class ImageLoader extends React.Component<ImageLoaderProps, {}> {
    img: HTMLImageElement;

    readonly state: IImageLoaderState = {
        status: this.props.src ? Status.LOADING : Status.PENDING
    }

    constructor(props: any, context?: any) {
        super(props, context);
        //this.state = {status: props.src ? Status.LOADING : Status.PENDING};
    }

    componentDidMount() {
        if (this.state.status === Status.LOADING) {
            this.createLoader();
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.props.src !== nextProps.src) {
            this.setState({
                status: nextProps.src ? Status.LOADING : Status.PENDING,
            });
        }
    }

    componentDidUpdate() {
        if (this.state.status === Status.LOADING && !this.img) {
            this.createLoader();
        }
    }

    componentWillUnmount() {
        this.destroyLoader();
    }

    createLoader() {
        this.destroyLoader();

        this.img = new Image();
        this.img.onload = this.handleLoad;
        this.img.onerror = this.handleError;
        this.img.src = this.props.src;
        this.img.srcset = this.props.srcSet || this.props.src;
    }

    destroyLoader() {
        if (this.img) {
            this.img.onload = null;
            this.img.onerror = null;
            this.img = null;
        }
    }

    handleLoad = (event: Event): void => {
        this.destroyLoader();
        this.setState({status: Status.LOADED});

        if (this.props.onLoad) {
            this.props.onLoad(event);
        }
    }

    handleError = (error: ErrorEvent): void => {
        this.destroyLoader();
        this.setState({status: Status.FAILED});

        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    getClassName(): string {
        let className: string = `imageloader imageloader-${this.state.status}`;
        if (this.props.className) {
            className = `${className} ${this.props.className}`;
        }
        return className;
    }

    render() {
        const {src, srcSet, children} = this.props;
        const childrenArray: ReactNode[] = React.Children.toArray(children);

        let content: any = (this.state.status === Status.LOADED) ? React.cloneElement(childrenArray[0] as ReactElement<any>, {
            src,
            srcSet
        }) : null;
        if (this.state.status === Status.FAILED && childrenArray[1]) {
            console.log("image " + src + " could not be loaded!");
            content = childrenArray[1];
        } else if ((this.state.status === Status.LOADING || this.state.status === Status.PENDING) && childrenArray[2]) {
            content = childrenArray[2];
        }

        return (
            <div className={this.getClassName()} style={this.props.style}>
                {content}
            </div>
        )
    }
}
